import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Actions from '../../../redux/actions';
import FindingsList from '../../Components/Finding/List';
import Collapse from '../../Components/Collapse';
import StatesPieChart from './StatesPieChart';
import WorldMap from './Worldmap';
import Safe from '../../Components/Safe';
import Scroller from './Scroller';

/* eslint-disable no-unused-vars */
class Dashboard extends React.Component {
  componentWillMount() {
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    if (this.props.orgId !== prevProps.orgId) {
      this.fetch();
    }
  }

  fetch = () => {
    this.props.processAllDataQueries();
    this.props.fetchFindings();
    this.props.fetchUsersForOrg();
  };

  retryDataQuery = (dataQueryKey) => {
    this.props.processDataQuery(dataQueryKey);
  };

  render() {
    const {
      scrollerStats,
      sourceLocationMapData,
      findingsStatesPieData,
      toplevel,
      secondlevel,
      withoutJurisdiction,
    } = this.props;

    const path = `pages.${toplevel}.${secondlevel}`;

    return (
      <div className='dashboard'>
        <div className='page-header'>
          <span className="page-title">
            <h1><Safe render safe path={path} value="title" /></h1>
          </span>
          <span className='page-description'>
            <p>| &nbsp; <Safe render safe path={path} value='description' /></p>
          </span>
        </div>
        <hr />
        <Scroller scrollerStats={scrollerStats} />
        <div className='dashboard-content'>
          <div className="findings">
            <div className="column-header">
              <div className='uppercase'>Your Queue</div>
            </div>
            <div className="findings-container">
              <FindingsList withoutJurisdiction={withoutJurisdiction} />
            </div>
          </div>
          <div className="trending">
            <div className='column-header'>
              <div className='uppercase'>Trending</div>
            </div>
            <div className='column-content'>
              <Collapse title='Finding States' height='100%'>
                <StatesPieChart
                  chartData={findingsStatesPieData}
                  handleRetry={() => {
                    this.retryDataQuery(findingsStatesPieData.key);
                  }}
                />
              </Collapse>
              <Collapse title='Finding Source Locations' height='100%'>
                <WorldMap
                  mapData={sourceLocationMapData}
                  handleRetry={() => {
                    this.retryDataQuery(sourceLocationMapData.key);
                  }}
                />
              </Collapse>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  fetchFindings: PropTypes.func.isRequired,
  fetchUsersForOrg: PropTypes.func.isRequired,
  findingsStatesPieData: PropTypes.shape({}).isRequired,
  orgId: PropTypes.string.isRequired,
  processAllDataQueries: PropTypes.func.isRequired,
  processDataQuery: PropTypes.func.isRequired,
  scrollerStats: PropTypes.shape({}).isRequired,
  secondlevel: PropTypes.string.isRequired,
  sourceLocationMapData: PropTypes.shape({}).isRequired,
  toplevel: PropTypes.string.isRequired,
  withoutJurisdiction: PropTypes.string.isRequired,
};

const mapStateToProps = ({ findings, dataQuery: { dataQueries } }) => ({
  findingsStatesPieData: dataQueries.DASHBOARD_PIE_CHART,
  scrollerStats: dataQueries.DASHBOARD_SCROLLER_STATS.visualizationData,
  sourceLocationMapData: dataQueries.DASHBOARD_WORLD_MAP,
});

const mapDispatchToProps = (dispatch, { withoutJurisdiction, orgId, user }) => ({
  processDataQuery: dataQueryKey => dispatch(Actions.DataQuery.processDataQueries(orgId, dataQueryKey)),
  processAllDataQueries: () => dispatch(Actions.DataQuery.processDataQueries(orgId)),
  fetchFindings: () => dispatch(Actions.Findings.fetchFindings({
    personId: user.id,
    orgId,
    withoutJurisdiction,
  })),
  fetchUsersForOrg: () => dispatch(Actions.User.fetchUsersForOrg(orgId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Pages/Dashboard/Dashboard.js